import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {RequestParameters} from '../shared/models/request-parameters/parameter.model';
import {GlobalVariable} from '../global';
import {Customer} from './customer.model';
import {Subject} from 'rxjs/Subject';
import { DatePipe } from '@angular/common';

@Injectable()
export class CustomerService {
  private subject = new Subject<any>();
  public updateFreezesData = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getFreezes(reference, parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/freezes/account/'+reference, {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }


  getUnfreezes(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/unfreezes', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }


  getCustomers (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/customers', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  getCustomer (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/customer/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  putCustomer (customer: Customer) {

    const body = this.normalizeCustomerData(customer);

    const datePipe = new DatePipe('en');

    if (body.cardExpiration) {
      body.cardExpiration  = datePipe.transform(body.cardExpiration, 'yyyy-MM-dd');
    } 

    return this.http.put(GlobalVariable.BASE_API_URL + '/customer/' + customer.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  patchCustomer (customer: Customer) {

    const body = this.normalizeCustomerData(customer);

    const datePipe = new DatePipe('en');

    if (body.cardExpiration) {
      body.cardExpiration  = datePipe.transform(body.cardExpiration, 'yyyy-MM-dd');
    } 
    
    return this.http.put(GlobalVariable.BASE_API_URL + '/customer/' + customer.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  resetCustomerPin (customer: Customer) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/customer/' + customer.reference + '/reset-pin')
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  validateAccountCustomer (customer: Customer) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/account/' + customer.phone + '/validate')
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );
  }
  invalidateAccountCustomer (customer: Customer) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/account/' + customer.phone + '/invalidate')
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );
  }

  blockAccountCustomer (customer: Customer) {

    return this.http.put(GlobalVariable.BASE_API_URL + '/account/' + customer.phone + '/block', {})
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  unBlockAccountCustomer (customer: Customer) {

    return this.http.put(GlobalVariable.BASE_API_URL + '/account/' + customer.phone + '/unblock', {})
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  private normalizeCustomerData(customer: Customer): Customer {
    const body = Object.assign({}, customer);
    delete body.reference;
    delete body.notificationType;
    if (body.picture !== null) {
      body.picture = body.picture.reference;
    }
    if (body.city !== null) {
      body.city = body.city.reference;
    }

    return body;
  }
  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  getCustomerLogs(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/logs', {
      params: parameters.getHttpParams()
    })
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  postFreeze(body) {
    const operation = body.operation;

    delete body.reference;
    delete body.unfreezingComment;
    delete body.action;
    delete body.operation;
    delete body.prefixedSentAmount;
    delete body.prefixedReceivedAmount;


    return this.http.post(GlobalVariable.BASE_API_URL + '/freeze/' + operation, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            message: JSON.parse(error.error).message
          });
        }
      );
  }

  postUnfreeze(body) {
    const reference = body.reference;
    delete body.reference;
    delete body.freezingComment;
    delete body.operation;
    delete body.prefixedSentAmount;
    delete body.prefixedReceivedAmount;
    
    return this.http.post(GlobalVariable.BASE_API_URL + '/unfreeze/' +
     reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            message: JSON.parse(error.error).message
          });
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/customer.service.ts